export default {
  api: {
    prefix: process.env.NODE_ENV === 'development'
      ? 'https://newcastle-cc-budget-sim.dev7.indigo.ws/'
      : '/'
  }
}



// WEBPACK FOOTER //
// ./src/config.js